import * as ACTION_TYPE from './constants';

export const controlPinBegin = () => ({
  type: ACTION_TYPE.CONTROL_PIN_BEGIN,
});

export const controlPinActive = payload => ({
  type: ACTION_TYPE.CONTROL_PIN_ACTIVE_SUCCESS,
  payload,
});

export const controlPinChange = payload => ({
  type: ACTION_TYPE.CONTROL_PIN_CHANGE_SUCCESS,
  payload,
});

export const controlPinCheck = payload => ({
  type: ACTION_TYPE.CONTROL_PIN_CHECK_SUCCESS,
  payload,
});

export const controlPinModify = payload => ({
  type: ACTION_TYPE.CONTROL_PIN_MODIFY_SUCCESS,
  payload,
});

export const controlPinRemind = payload => ({
  type: ACTION_TYPE.CONTROL_PIN_REMIND_SUCCESS,
  payload,
});

export const controlPinSet = payload => ({
  type: ACTION_TYPE.CONTROL_PIN_SET_SUCCESS,
  payload,
});

export const controlPinStatus = payload => ({
  type: ACTION_TYPE.CONTROL_PIN_STATUS_SUCCESS,
  payload,
});

export const controlPinError = payload => ({
  type: ACTION_TYPE.CONTROL_PIN_ERROR,
  payload,
});
